import SelectAutoComplete from '@component/form/selectAutoComplete';
import { Box } from '@mui/material';
import axiosInstance from '@utils/axios';
import { find } from 'lodash';
import { useRouter } from 'node_modules/next/router';
import React from 'react';
import useAuth from 'src/hooks/useAuth';
import useCompany from 'src/hooks/useCompany';
import { getUserCompany } from 'src/redux/slices/company';
import { useDispatch, useSelector } from 'src/redux/store';

const NotAllowD = [
  'form',
  'qr_setting',
  'company_settings',
  'promo_code',
  'blog',
  'company_statuses',
  'catalog',
  'user_statuses',
];
const AllowD = [];

const isShowData = ['/dashboard/tag/tag_scan'];

const NotAllow = () => {
  const url = window.location.href;
  const getD = url?.split('/');
  const found = getD.some((r) => NotAllowD.indexOf(r) >= 0);
  return found;
};

const Allow = () => {
  const url = window.location.href;
  const getD = url?.split('/');
  const found = getD.some((r) => AllowD.indexOf(r) >= 0);
  return found;
};

const isShow = (path) => {
  let show = false;
  show = isShowData.includes(path);

  return show;
};

export default function SelectCompany() {
  const { user } = useAuth();
  const { companyId, setCompany, setCompanyDetail, companyDetail } = useCompany();
  const { userCompanies, isUserCompanyLoading } = useSelector((state) => state.company);
  const dispatch = useDispatch();
  const router = useRouter();
  React.useEffect(() => {
    getGeo()
    dispatch(getUserCompany());
  }, [dispatch, companyId]);

  const getGeo = () => {
    const location = window.navigator && window.navigator.geolocation
    if (location) {
      location.getCurrentPosition((position) => {
        console.log(position.coords.latitude, 'position.coords')
        axiosInstance.defaults.headers.common['latitude'] = position.coords.latitude; //Support of "latitude" in header
        axiosInstance.defaults.headers.common['longitude'] = position.coords.longitude; //Support of "longitude" in header
      }, (error) => {
        console.log(error, "eror")
      })
    }
  }

  //After Login Default company Set
  React.useEffect(() => {
    if (user && !companyId) {
      const company_id = JSON.parse(window.localStorage.getItem('companyId')) || user?.company_id;
      axiosInstance.defaults.headers.common.company_id = company_id;
      axiosInstance.defaults.headers.common.platform = 'frontend';
      setCompany(company_id);
    }
  }, [user]);

  React.useEffect(() => {
    if (user && user?.company_id && !companyDetail) {
      const company_id = JSON.parse(window.localStorage.getItem('companyId')) || user?.company_id;
      let findCompany = find(userCompanies, { id: Number(company_id) });
      setCompanyDetail(JSON.stringify(findCompany));
    }
  }, [user, userCompanies, user?.company_id]);

  return (
    <>
      {!isShow(router?.pathname) && (
        <Box sx={{ my: 1.5, px: 2.5, width: 250, color: '#333' }}>
          <SelectAutoComplete
            fullWidth
            name={`company_id`}
            label="Company"
            disabled={!Allow() && NotAllow()} //we should (not allow/allow) company change in Add/Edit
            placeholder="Company"
            value={companyId}
            options={userCompanies || []}
            loading={isUserCompanyLoading}
            getOptionLabel="name"
            getOptionValue="id"
            disableClearable
            onChange={(e) => {
              if (e) {
                setCompany(e);
                let findCompany = find(userCompanies, { id: Number(e) });
                setCompanyDetail(JSON.stringify(findCompany));
              } else {
                setCompany(null);
              }
            }}
          />
        </Box>
      )}
    </>
  );
}
